export default __webpack_public_path__ + "static/applicationDevelopmentBanner-0d5eee9358cc91c36477a45f5202534c.svg";